import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';

interface IParams {
    organizationUuid: string;
    dealId: number;
    postData: {
        fileName: string;
    };
}

const createUploadUrl = async ({ organizationUuid, dealId, postData }: IParams): Promise<any> => {
    const response = await axiosInstance.post(API_ENDPOINTS.UPLOADED_PRO_FORMA.PRESIGNED_URL(organizationUuid, dealId), postData);
    return response.data;
};

export const useCreateTemporaryProFormaUrl = () => useMutation({
    mutationFn: createUploadUrl,
});

export default useCreateTemporaryProFormaUrl;
